import { render } from "./novo-contato.vue?vue&type=template&id=1612acdc"
import script from "./novo-contato.vue?vue&type=script&lang=js"
export * from "./novo-contato.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__